import { Injectable } from '@angular/core';
import { NetworkService } from 'src/app/core/services/network.service';
import { EnvironmentService } from 'src/app/core/services/environment.service';
import { DataService } from '../../../shared/service/data.service';

@Injectable()

export class RequesterService {

  constructor(
    private envser: EnvironmentService,
    private networkSer: NetworkService,
    private dataService: DataService
  ) { }

  getWasteData(selectedGranularityLevel?, selectedDetail?, dateFilterdata?): any {
    const req = this.dataService.getWasteData(selectedGranularityLevel, selectedDetail, dateFilterdata);

    const serviceUrl = req.serviceUrl;

    delete req.serviceUrl;
    delete req.wasteFor;
    delete req.ClusterId;
    delete req.FactoryId;

    return this.networkSer.httpReq('get', serviceUrl, req);
  }

}
